import { ModuleFE_BaseSandboxModule } from '../ModuleFE_BaseSandboxModule.js';
import { __stringify } from '@nu-art/ts-common';
import { ModuleFE_EMInterface } from '../../../../_entity/runtime/em-interface/index.js';
export class ModuleFE_SandboxFHIR_Class extends ModuleFE_BaseSandboxModule {
    constructor() {
        super('storage-fhir-sandbox', []);
    }
    async listTemplates() {
        // Return templates from config (loaded from RTDB or default)
        // For 'read' requests: params should be a string (the resource ID)
        // For 'search' requests: params should be an object (query parameters)
        return this.config.FHIRRequests ?? [
            {
                label: 'Read Patient',
                content: {
                    fhirRequestType: 'read',
                    resource: 'Patient',
                    params: 'example-patient-id'
                }
            },
            {
                label: 'Read Encounter',
                content: {
                    fhirRequestType: 'read',
                    resource: 'Encounter',
                    params: 'example-encounter-id'
                }
            },
            {
                label: 'Search Observations',
                content: {
                    fhirRequestType: 'search',
                    resource: 'Observation',
                    params: {
                        patient: 'example-patient-id',
                        category: 'vital-signs'
                    }
                }
            },
            {
                label: 'Search Conditions',
                content: {
                    fhirRequestType: 'search',
                    resource: 'Condition',
                    params: {
                        patient: 'example-patient-id',
                        'clinical-status': 'active'
                    }
                }
            }
        ];
    }
    async sendRequest(template, content) {
        // Parse the edited content from the textarea (not the template content)
        let parsedRequest;
        try {
            parsedRequest = JSON.parse(content);
        }
        catch (e) {
            this.logError('Failed to parse request content as JSON', e);
            this.addErrorMessageToHistory('Failed to parse request: Invalid JSON');
            return;
        }
        // Validate request structure
        if (!parsedRequest.fhirRequestType || !parsedRequest.resource) {
            this.addErrorMessageToHistory('Invalid request: missing fhirRequestType or resource');
            return;
        }
        // Build request object for BodyApi (POST request with body)
        // params can be an object (for search) or string (for read) - will be JSON serialized in body
        const request = {
            fhirRequestType: parsedRequest.fhirRequestType,
            resource: parsedRequest.resource,
            params: parsedRequest.params // Keep as-is (object or string) - BodyApi will serialize it
        };
        // Add sent message to history
        this.addMessageToHistory({ type: 'sent', content });
        try {
            // Log the request for debugging
            this.logErrorBold('FHIR Sandbox Request:', request);
            // Call the API
            const response = await ModuleFE_EMInterface.vv1.sandbox.fhirSandbox(request).executeSync();
            // Format response for display
            const responseContent = typeof response.response === 'string'
                ? response.response
                : __stringify(response.response, true);
            // Add received message to history
            this.addMessageToHistory({ type: 'received', content: responseContent });
        }
        catch (err) {
            this.logError('Failed to send FHIR sandbox request', err);
            this.addErrorMessageToHistory(`Failed to send request: ${err.message || err}`);
        }
    }
}
export const ModuleFE_SandboxFHIR = new ModuleFE_SandboxFHIR_Class();
//# sourceMappingURL=ModuleFE_SandboxFHIR.js.map